import { render, staticRenderFns } from "./ThgChargingStationCreate.vue?vue&type=template&id=183ff701&"
import script from "./ThgChargingStationCreate.vue?vue&type=script&lang=ts&"
export * from "./ThgChargingStationCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports